import jwtDecode from "jwt-decode";
import redirect from "lib/redirect";
import { destroyCookie, parseCookies, setCookie } from "nookies";
import * as authConstants from "../constants";

export const getBaseUrl = () =>
  `${window.location.protocol}//${window.location.host}`;

const getAuth0 = () => {
  const auth0 = require("auth0-js");

  return new auth0.WebAuth({
    clientID: process.env.NEXT_PUBLIC_AUTH0_CLIENT_ID,
    domain: process.env.NEXT_PUBLIC_AUTH0_DOMAIN,
    responseType: "token id_token",
    scope: "openid email",
    redirectUri: `${getBaseUrl()}/auth/signed-in`,
  });
};

export const signupAndLogin = (email, password, resetStore) =>
  signup(email, password).then((res) => login(email, password));

export const signup = (email, password) => {
  return new Promise((resolve, reject) => {
    getAuth0().signup(
      {
        connection: "Username-Password-Authentication",
        email,
        password,
        user_metadata: {},
      },
      (err, result) => {
        err ? reject(err) : resolve(result);
      }
    );
  });
};

export const login = async (email, password) => {
  await new Promise((resolve, reject) => {
    getAuth0().login(
      {
        email,
        password,
        realm: "Username-Password-Authentication",
        // This redirects to whatever is set as the redirectUri (/auth/signed-in)
      },
      (err, result) => {
        err ? reject(err) : resolve(result);
      }
    );
  });
};

export const logout = ({ returnTo = "" }) => {
  destroyCookie({}, authConstants.idToken, { path: "/" });
  destroyCookie({}, authConstants.accessToken, { path: "/" });

  // to support logging out from all windows
  window.localStorage.setItem("logout", Date.now());

  getAuth0().logout({
    clientID: process.env.NEXT_PUBLIC_AUTH0_CLIENT_ID,
    returnTo: `${getBaseUrl()}${returnTo}`,
  });
};

export const changePassword = (email) =>
  new Promise((resolve, reject) => {
    getAuth0().changePassword(
      {
        connection: "Username-Password-Authentication",
        email,
      },
      (err, result) => {
        err ? reject(err) : resolve(result);
      }
    );
  });

export const parseHash = () => {
  return new Promise((resolve, reject) => {
    getAuth0().parseHash((error, result) => {
      error ? reject(error) : resolve(result);
    });
  });
};

const getIdTokenExpiration = (token) => {
  const jwt = jwtDecode(token);

  // seems to be some timezone issue by using `exp` directly,
  // so instead calculate token expiration by subtracting from issue time.
  const exp = jwt.exp - jwt.iat;
  return new Date(exp * 1000 + Date.now());
};

export const saveAuthToken = async () => {
  const { idToken, accessToken } = await parseHash();
  const opts = { expires: getIdTokenExpiration(idToken), path: "/" };
  setCookie({}, authConstants.idToken, idToken, opts);
  setCookie(
    {},
    "idToken-reminder",
    "WAIT! Deleting this cookie won't log the user out of auth0. Use /auth/sign-out",
    opts
  );
  setCookie({}, authConstants.accessToken, accessToken, opts);
};

export const getStoredIdToken = async (ctx) => {
  return parseCookies(ctx).idToken;
};

export const getDecodedIdToken = async (ctx) => {
  const jwt = await getStoredIdToken(ctx);
  if (jwt) {
    return jwtDecode(jwt);
  }
};

// For cross-origin staging
// https://auth0.com/docs/cross-origin-authentication#create-a-cross-origin-verification-page
export const crossOriginVerification = () => {
  getAuth0().crossOriginVerification();
};

// TODO: Check token expiry time in auth0. We can probably reduce it now
// export const refresh = () => {
//   const newTokens = new Promise((resolve, reject) => {
//     getAuth0().checkSession({}, (err, result) => {
//       err ? reject(err) : resolve(result);
//     });
//   });
//   saveAuthToken(newTokens);
// };

export const reauthenticate = (ctx) => {
  console.log("Invalid auth token, redirecting to sign out");
  redirect(ctx, "/auth/sign-out?returnTo=/auth/sign-in");
};

export const isAppReviewer = () => false;
